<template>
  <div class="bg-white">
    <div class="my-order" ref="container">
      <div class="header bg-color-red">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="text">
            <div class="name">我的收货单</div>
          </div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <div class="item" :class="{ on: type === 1}" @click="changeType(1)">
          <div>待收货</div>
          <div class="num">{{ statistics[0] }}</div>
        </div>
        <div class="item" :class="{ on: type === 2 }" @click="changeType(2)">
          <div>已收货</div>
          <div class="num">{{ statistics[1] }}</div>
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in orderList" :key="index">
          <div class="header-title acea-row row-between-wrapper">
            <div class="row-middle">
              <p>发货单号：{{ item.fhdh }}</p>
            </div>
            <div class="font-color-red">{{ status[item.status] }}</div>
          </div>
          <div class="item-con">
            <div class="right-arrow" @click="goDetail(item._ID)">
              <van-icon name="arrow" size="0.4rem" />
            </div>
            <div class="item-info acea-row row-between row-top">
              <div class="text">
                <p class="name">
                  {{ item.consignee_name }}
                  <span class="marginL20">{{ item.consignee_phone }}</span>
                </p>
                <p class="margin10">{{ item.consignee_address }}</p>
                <!-- <p>销售单号：xsd123456789</p> -->
              </div>
            </div>
            <div class="total-price">
              共{{ item.total_num }}件商品，
              <span class="money font-color-red"
                >发货金额：¥{{ item.total_price * 1 }}</span
              >
            </div>
            <div class="order-num">
              <p>订单号:{{ item.order_id }}</p>
              <p>订单时间:{{ item.create_time }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="noCart" v-if="orderList.length === 0 && page > 1">
        <div class="pictrue">
          <img src="@assets/images/noOrder.png" />
        </div>
      </div>
      <Loading :loaded="loaded" :loading="loading"></Loading>
      <GeneralWindow
        :generalActive="generalActive"
        @closeGeneralWindow="closeGeneralWindow"
        :generalContent="generalContent"
      ></GeneralWindow>
    </div>
  </div>
</template>
<script>
import { getDispatchStatistics, getDispatchList } from "@api/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import GeneralWindow from "@components/GeneralWindow";

const NAME = "dispatchList";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 1,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      limitTime: 0,
      orderList: [],
      status: {
        "1": "待收货",
        "2": "已收货"
      },
      pay: false,
      payType: ["yue", "weixin"],
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      statistics: {
        wait: 0,
        has: 0
      }
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
          console.log(this.type);
        }
        // this.getOrderData();
      }
    }
  },
  methods: {
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    goDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/myOrder/dispatchBill",
        query: {
          orderId: id
        }
      });
    },
    getOrderStatistics() {
      getDispatchStatistics()
        .then(res => {
          console.log(res);
          this.statistics = res.data;
        })
        .catch(e => {
          console.log(e);
          if (e.msg == "ok") {
            this.statistics = e.data.data;
          }
        });
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, limitTime } = this;
      getDispatchList({
        page,
        limit,
        limitTime,
        status: this.type
      }).then(res => {
        this.orderList = this.orderList.concat(res.data);
        // this.limitTime = res.data.limitTime;
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      console.log(type,22222222)
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getStatus(order) {
      return STATUS[order._status._type];
    }
  },
  mounted() {
    console.log(2222222222);
    // this.getOrderData();
    this.getOrderStatistics();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.bg-white {
  height: 100%;
  width: 100%;
  background: white !important;
}
.nav {
  border: 1px solid rgb(245, 245, 245);
  box-shadow: 2px 2px 0px #eeeeee;
}
.list .item {
  border: 1px solid rgb(245, 245, 245);
  box-shadow: 2px 2px 0px #eeeeee;
}
.item_info {
  color: #a1a1a1;
}
.header-title {
  height: 0.84rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.28rem;
  color: #a1a1a1;
  background: #eeeeee;
}
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}
.total-price,
.order-num {
  font-size: 0.28rem;
  color: #a1a1a1;
  margin: 0.14rem 0 0 0.3rem;
  padding: 0 0.3rem 0.3rem 0;
}
.order-num {
  font-size: 0.26rem;
}
.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.name span.marginL20 {
  color: #a1a1a1;
}
.item-con {
  position: relative;
}
.right-arrow {
  background: red;
  color: white;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  right: 0.4rem;
  margin-top: -0.4rem;
  text-align: center;
  box-sizing: border-box;
  padding-top: 0.05rem;
}
.marginL20 {
  margin-left: 0.4rem;
}
.margin10 {
  margin: 0.14rem 0;
}
.order-date {
  font-size: 0.2rem;
  color: #999;
}
</style>
